import * as exInstance from '../../utils/instance';

import type { IManagerConfig, IManagerApi } from './types';
import exManager from './manager';

// ----------------------------------------------------------------------------

const instance = new exInstance.instanceManager<IManagerApi>();

// ----------------------------------------------------------------------------

export type TypeMountManyElements = HTMLSelectElement[] | NodeListOf<HTMLSelectElement>;

// ----------------------------------------------------------------------------

function mount(element: HTMLSelectElement, config: IManagerConfig = {}): IManagerApi | undefined {
    if (!(element instanceof HTMLSelectElement)) {
        throw new Error('The element is not HTMLSelectElement!');
    }

    if (!instance.has(element)) {
        const managerSelect = exManager(element, config);
        instance.add(element, managerSelect);
    }

    return instance.get(element);
}

function mountMany(elements: TypeMountManyElements, config: IManagerConfig = {}): IManagerApi[] {
    const instances: IManagerApi[] = [];

    for (const element of elements) {
        const instance = mount(element, config);

        if (instance) {
            instances.push(instance);
        }
    }

    return instances;
}

// ----------------------------------------------------------------------------

export { mount, mountMany };
